<template>
	<div class="center-conf" ref="imgWrap">
		<div class="img-wrap">
			<img class="current-img" :src="currentImg" ref="currentImgPage" crossOrigin="anonymous" />
			<temp-title v-if="areaType === 'title'"></temp-title>
			<temp-lack v-if="areaType === 'lack'"></temp-lack>
			<temp-slice v-if="areaType === 'slice'"></temp-slice>
			<temp-subjective v-if="areaType === 'subjective'"></temp-subjective>
			<temp-number v-if="areaType === 'examNo'"></temp-number>
			<temp-select v-if="areaType === 'choose'"></temp-select>
			<temp-objective v-show="areaType === 'objective' && !tempReferTabState"></temp-objective>
			<temp-refer v-if="tempReferTabState"></temp-refer>
			<fix-temp v-if="fixReferState"></fix-temp>
		</div>
	</div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import tempTitle from './temp-title'
import tempNumber from './temp-No'
import tempObjective from './temp-objective'
import tempSubjective from './temp-subjective'
import tempLack from './temp-lack'
import tempRefer from './temp-refer'
import fixTemp from './fix-temp'
import tempSelect from './temp-select'
import tempSlice from './temp-slice'
export default {
	name: 'center-configuration',
	components: {
		tempTitle,
		tempNumber,
		tempObjective,
		tempSubjective,
		tempLack,
		tempRefer,
		fixTemp,
		tempSelect,
		tempSlice
	},
	data() {
		return {
			//当前答题卡
			currentImg: '',
			//答题卡list
			imgList: [],
			//题块类型
			areaType: 'title',
			//试卷宽度
			pageWidth: 0,
			//试卷高队
			pageHeight: 0,
			//当前题块
			tabChangeInfo: [],
			fixTempState: false,
			//答题卡信息
			imgInfos: {},
			//参考模板 dialog state
			fixReferState: false
		}
	},
	watch: {
		//当前图片信息
		currentImg() {
			const _this = this
			setTimeout(function() {
				_this.operateScale()
			})
		},
		//当前参考的图片信息
		tempCurrentRefer: {
			handler(val) {
				this.fixReferState = false
				if (val.base64Img.length > 0) {
					this.fixReferState = true
				}
			},
			deep: true,
			immediate: true
		},
		//缩放
		tempScalePage() {
			this.handleScalePaper()
		},
		tempEditImgInfo(val) {
			this.imgInfos = val
			if (this.tabChangeInfo === 'slice') {
				this.imgList = val.originList
				this.currentImg = this.imgList[this.tempCurrentImgIndex.curIndex]
			} else {
				this.imgList = val.list
				this.currentImg = this.imgList[this.tempCurrentImgIndex.curIndex]
			}
			const _this = this
			this.$nextTick(() => {
				setTimeout(() => {
					_this.operateScale()
				})
			})
		},
		tabActive(val) {
			this.tabChangeInfo = val
			this.changeTabInfo(val)
			if (val === 'slice') {
				this.imgList = this.imgInfos.originList
				this.currentImg = this.imgList[this.tempCurrentImgIndex.curIndex]
			} else {
				this.imgList = this.imgInfos.list
				this.currentImg = this.imgList[this.tempCurrentImgIndex.curIndex]
			}
			this.setTempCurrentImgIndex({ curIndex: this.tempCurrentImgIndex.curIndex })
		},
		operateCurPage(val) {
			if (val.dir === 'prev') {
				this.prevImg()
			} else if (val.dir === 'next') {
				this.nextImg()
			}
		},
		tempReferTabState(val) {
			if (val) {
				this.areaType = 'refer'
			} else {
				this.changeTabInfo(this.tabChangeInfo)
			}
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'dotType',
			'tabActive',
			'tempScalePage',
			'operateCurPage',
			'tempReferTabState',
			'tempEditImgInfo',
			'tempCurrentRefer',
			'tempCurrentImgIndex'
		])
	},
	created() {
		this.changeTabInfo()
	},
	methods: {
		...mapMutations('examination/configation', [
			'setTempImgZoomRate',
			'setTempRectTitle',
			'setTempRectExamNoInfo',
			'setTempCurrentImgIndex',
			'setTempChooseList',
			'setTempLack',
			'setTempRectObjective',
			'setTempRectSubjective'
		]),
		//设置图片缩放
		handleScalePaper() {
			this.$refs['imgWrap'].style.transform = `scale(${this.tempScalePage})`
			this.$refs['imgWrap'].style.transformOrigin = '0 0'
			this.operateScale()
		},
		//根据题块的数据
		changeTabInfo(cb) {
			if (!cb) return false
			this.areaType = cb
			switch (cb) {
				case 'title':
					this.setTempRectTitle(this.dotType.title)
					break
				case 'examNo':
					this.setTempRectExamNoInfo(this.dotType.examNo)
					break
				case 'objective':
					this.setTempRectObjective({ val: this.dotType.objective, state: true })
					break
				case 'subjective':
					this.setTempRectSubjective(this.dotType.subjective)
					break
				case 'choose':
					this.setTempChooseList(this.dotType.choose)
					break
				case 'lack':
					this.setTempLack(this.dotType.lack)
					break
			}
		},
		//计算缩放 为了试卷缩放到一个合适的大小
		operateScale() {
			let _this = this
			let img = new Image()
			img.src = this.currentImg
			img.onload = function() {
				_this.pageWidth = img.width
				_this.pageHeight = img.height
				_this.concludeScale()
			}
		},
		concludeScale() {
			const page = { pageWidth: this.pageWidth, pageHeight: this.pageHeight }
			this.setTempImgZoomRate(page)
		},
		// 上一页
		prevImg() {
			let curIndex = this.tempCurrentImgIndex.curIndex
			curIndex = curIndex - 1 < 0 ? this.imgList.length - 1 : curIndex - 1
			this.currentImg = this.imgList[curIndex]
			this.setTempCurrentImgIndex({ curIndex: curIndex })
		},
		// 下一页
		nextImg() {
			let curIndex = this.tempCurrentImgIndex.curIndex
			curIndex = curIndex + 1 > this.imgList.length - 1 ? 0 : curIndex + 1
			this.currentImg = this.imgList[curIndex]
			this.setTempCurrentImgIndex({ curIndex: curIndex })
		}
	}
}
</script>

<style scoped lang="less">
.center-conf {
	position: relative;
	&:hover .iconfont {
		display: block;
	}
	.iconfont {
		position: fixed;
		top: 50%;
		font-size: 50px;
		color: #386762;
		border-radius: 10px;
		z-index: 12;
		display: none;
		&:hover {
			cursor: pointer;
		}
	}
	.iconjiantouzuo {
		left: 130px;
	}
	.iconjiantouyou {
		right: 180px;
	}
	.img-wrap {
		position: relative;
	}
	.current-img {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
	}
}
</style>
